import React from 'react';
import Layout from './../components/shared/Layout';
import Showcase from './../components/home/Showcase';
import HomeSections from './../components/home/HomeSections';

const Home = () => (
  <Layout>
    <Showcase />
    <HomeSections />
  </Layout>
)

export default Home;
